import { render, staticRenderFns } from "./bindings-modal-content.component.vue?vue&type=template&id=566c1848"
import script from "./bindings-modal-content.component.vue?vue&type=script&lang=js"
export * from "./bindings-modal-content.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports